module.exports = __webpack_public_path__ + "googleplay.png?4bf402d19866038ffcf0a12761aaca46";


//////////////////
// WEBPACK FOOTER
// ./static/googleplay.png
// module id = 6
// module chunks = 0